export type UserInfoJwt = {
  name: string;
  email: string;
  employeeId?: string;
};

export type SessionTokenJwt = {
  exp: number;
  iat: number;
};

export function parseJwt<T>(token?: string | null): T | null {
  if (!token) return null;

  const base64Url = token.split('.')[1];

  if (!base64Url) return null;

  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

  const payload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((character) => `%${`00${character.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  try {
    return JSON.parse(payload);
  } catch {
    return null;
  }
}
